import { AlpineData, LivewireData, LivewireMethods } from "@/js/interfaces/Components/alpinejs/SecondCounter";
import { createAlpineLivewireComponent } from "@nolikein/typed-alpinejs";
import { AlpineWired } from "@nolikein/types-livewire3";

type Self = AlpineWired.AlpineComponentSelf<AlpineData, LivewireData, LivewireMethods>;

export default {
    name: 'SecondCounter',
    component: (initialSeconds = 5) => createAlpineLivewireComponent<AlpineData, LivewireData, LivewireMethods>({
        seconds: initialSeconds,
        intervalId: null,

        init() {
            this.restartCounter(initialSeconds);
        },

        /**
         * Update the second display
         */
        updateTime(self: Self): void {
            self.seconds -= 1;
            if (0 === self.seconds) {
                self.removeTimer();
            }
        },

        /**
         * Restart the counter
         *
         * @param restartWithSeconds The initial seconds time
         */
        restartCounter(restartWithSeconds: number): void {
            this.removeTimer();
            this.seconds = restartWithSeconds;
            this.intervalId = setInterval(() => { this.updateTime(this); }, 1000);
        },

        /**
         * Remove the runned timer
         */
        removeTimer(): void {
            if (null !== this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
    }),
};
